"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganization = useOrganization;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useOrganization(id) {
    const organizations = (0, stores_1.useCalculatorStore)((state) => state.data.organizations);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    return (0, react_1.useMemo)(() => {
        const organization = organizations?.find((organization) => organization.id === id);
        return organization ? (0, view_models_1.organizationViewModel)(organization, baseUrl) : undefined;
    }, [organizations, id, baseUrl]);
}
